import { render } from "./TextDedup.vue?vue&type=template&id=190a9b1e&scoped=true"
import script from "./TextDedup.vue?vue&type=script&lang=js"
export * from "./TextDedup.vue?vue&type=script&lang=js"

import "./TextDedup.vue?vue&type=style&index=0&id=190a9b1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190a9b1e"]])

export default __exports__